import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { LegalInvestigationsHistoryModel } from './types';
import { legalInvestigationsClearanceHistoryItemValidator, legalInvestigationsHistoryItemValidator } from './validators/item';

const legalInvestigationsHistoryValidator: ValidateJSModel<LegalInvestigationsHistoryModel> = {
  HasHistory: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasHistory && attributes?.HasHistory.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsHistoryItemValidator },
      };
    }
    return {};
  },
  HasClearanceHistory: (value, attributes, attributeName, options) => {
    if (!isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  ClearanceHistoryList: (value, attributes, attributeName, options) => {
    if (!isPVQForm(options?.formType)) {
      return {};
    }

    if (attributes?.HasClearanceHistory && attributes?.HasClearanceHistory.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsClearanceHistoryItemValidator },
      };
    }
    return {};
  },
};
export default legalInvestigationsHistoryValidator;
